



































import PlaceCard from './PlaceCard.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'PlaceList',

    components: {
        PlaceCard,
    },

    props: {
        showNoPlacesMessage: {
            type: Boolean,
            default: false,
        },
        places: {
            type: Array,
            required: true,
        },
    },

    computed: {
        placesWithReviews() {
            return this.places.filter((p) => p.hasReviews);
        },
        placesWithoutReviews() {
            return this.places.filter((p) => !p.hasReviews);
        },
    },
});
